import { gql } from '@apollo/client';

export const fetchQuotesByOrderLineId = gql`
  query fetchQuotesByOrderLineId($searchOptions: ConnectionSearchOptions, $filterOptions: FilterOption) {
    quotes(searchOptions: $searchOptions, filterOptions: $filterOptions) {
      totalCount
      nodes {
        id
        quoteNumber
      }
    }
  }
`;
